module.exports = __webpack_public_path__ + "img/20191227155033737.8c0341fc.jpg";